// ACTION CREATORS
import {
    SET_CART_ITEMS_DATA,
    SET_CART_IMAGES_DATA,
    SET_CART_DETAILS,
    SET_COUPON,
    EMPTY_CART,
} from "redux/actions/constants/action-types";

const initialState = {
    cartItems: [],
    cartImages: null,
    cartDetails: null,
    appliedCoupon: "",
};

function cartReducer(state = initialState, action) {
    if (action.type === SET_CART_ITEMS_DATA) {
        return {
            ...state,
            cartItems: action.payload,
        };
    }

    if (action.type === SET_CART_IMAGES_DATA) {
        return {
            ...state,
            cartImages: action.payload,
        };
    }

    if (action.type === SET_CART_DETAILS) {
        return {
            ...state,
            cartDetails: action.payload,
        };
    }

    if (action.type === SET_COUPON) {
        return {
            ...state,
            appliedCoupon: action.payload,
        };
    }

    if (action.type === EMPTY_CART) {
        return {
            ...state,
            cartItems: [],
            cartImages: null,
            cartDetails: null,
            appliedCoupon: "",
        };
    }
    return state;
}

export default cartReducer;
